import {initialNotificationsState, INotificationsState} from '@app/core/store/state/notifications.state';
import {ErrorActions} from '@app/core/store/actions/error.actions';
import {ENotificationsActions, NotificationsActions} from '@app/core/store/actions/notifications.actions';
import {EMessagesActions, MessagesActions, SetSelectedConversation} from '@app/core/store/actions/messages.actions';

export const notificationsReducers = (
	state = initialNotificationsState,
	action: NotificationsActions | ErrorActions | MessagesActions,
): INotificationsState => {

	switch (action.type) {
		case ENotificationsActions.GetLatestNotifications: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ENotificationsActions.GetLatestNotificationsSuccess: {
			return {
				...state,
				isLoading: false,
				notifications: action.notifications,
			};
		}
		case ENotificationsActions.SetNotifications: {
			return {
				...state,
				notifications: action.notifications,
			};
		}
		case ENotificationsActions.GetNotificationNumbers: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ENotificationsActions.GetNotificationNumbersSuccess: {
			return {
				...state,
				isLoading: false,
				notificationNumbers: action.notificationNumbers,
			};
		}
		case ENotificationsActions.SetNotificationNumbers: {
			return {
				...state,
				notificationNumbers: action.notificationNumbers
			};
		}
		case EMessagesActions.CreateMessage:
		case EMessagesActions.SetSelectedConversation: {
			const conversationId = (action instanceof SetSelectedConversation)
				? action.conversation.id
				: action.id;
			const notificationNumbers = {...state.notificationNumbers};
			if (notificationNumbers.conversation_to_messages[conversationId]) {
				delete notificationNumbers.conversation_to_messages[conversationId];
				notificationNumbers.conversations--;
				notificationNumbers.total_amount_of_notifications--;
			}
			return {
				...state,
				notificationNumbers,
			};
		}
		case ENotificationsActions.MarkAllNotificationsAsRead: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ENotificationsActions.MarkAllNotificationsAsReadSuccess: {
			return {
				...state,
				isLoading: false,
				notificationNumbers: {
					conversation_to_messages: {},
					conversations: 0,
					dashboard: 0,
					message_board_posts: 0,
					shifts: 0,
					sick_messages: 0,
					availabilities: 0,
					total_amount_of_notifications: 0,
				},
			};
		}
		case ENotificationsActions.MarkConversationAsRead: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ENotificationsActions.MarkConversationAsReadSuccess: {
			const numbers = state.notificationNumbers;
			if (numbers.conversations > 0) {
				numbers.conversations--;
			}

			delete numbers.conversation_to_messages[action.conversationId];

			return {
				...state,
				isLoading: false,
				notificationNumbers: numbers,
			};
		}
		case ENotificationsActions.MarkNotificationAsRead: {
			return {
				...state,
				notifications: state.notifications.map(n => n.id === action.notification.id ? action.notification : n),
			};
		}
		case ENotificationsActions.SetShowNotifications: {
			return {
				...state,
				showNotifications: action.show,
			};
		}
		default:
			return state;
	}
};
